import { render } from "./DetalharTurma.vue?vue&type=template&id=8f08441a&scoped=true"
import script from "./DetalharTurma.vue?vue&type=script&lang=js"
export * from "./DetalharTurma.vue?vue&type=script&lang=js"

import "./DetalharTurma.vue?vue&type=style&index=0&id=8f08441a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f08441a"]])

export default __exports__